// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/text-align-start.js';

import { paths } from '../generated/text-align-start';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('text-align-start', Original, paths);
